// App-wide state shared through context: who is signed in, home data, install prompt.
import { createContext } from 'preact';
import { useContext } from 'preact/hooks';

export const AppContext = createContext(null);
export const useApp = () => useContext(AppContext);

export function isStandalone() {
  return (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) || navigator.standalone === true;
}

export function isIOS() {
  const ua = navigator.userAgent;
  return /iPhone|iPad|iPod/.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1);
}

// Safari keeps an embedded OneDrive player from signing in, so recordings open in a new tab there.
export function opensInNewTab(mode) {
  if (mode === 'newtab') return true;
  if (mode === 'embed') return false;
  const ua = navigator.userAgent;
  const safari = /Safari\//.test(ua) && !/Chrome\/|CriOS|Edg\/|EdgiOS|EdgA|FxiOS|Android|SamsungBrowser/.test(ua);
  return isIOS() || safari;
}
